// base_info_view_4_1 
import React, { useRef, useState, useEffect } from 'react'
import BaseBulkActionControl1 from './base_bulk_action_control_1'
import { Row, Col } from '../ui/ot'
const BaseInfoView4_1 = ({
    baseBulkActionControl1Props = {
        checkedAll: false,
        onToggleAll: () => { },
        selectedCount: 0,
        selectedTotal: 0,
        actionList: [{ label: "批次刪除", value: "delete" }],
        onActionClick: () => { },
        selectLabel: "選擇本頁所有項目",
        selectCountBadge: true,
        getcheckboxJSX: () => { }, //取得checkbox
        showComponent: ["BaseBulkActionControl1_1", "BaseBulkActionControl1_2", "BaseBulkActionControl1_3"]
    }

}) => {
    const bulk1Ref = useRef()
    const [checkboxJSX, setCheckboxJSX] = useState(null)

    useEffect(() => {
        if (bulk1Ref.current?.getCheckBoxAll) {
            const result = bulk1Ref.current.getCheckBoxAll()
            setCheckboxJSX(result)
            baseBulkActionControl1Props.getcheckboxJSX(result)
        }
    }, [baseBulkActionControl1Props?.checkedAll])

    return (<Row>
        <Col span={24}>
            < BaseBulkActionControl1
                ref={bulk1Ref}
                {...baseBulkActionControl1Props}
            />
        </Col>
    </Row>)
}
export default BaseInfoView4_1
